// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"c8f6fc85","426":"577820bb","453":"39fc1c25","644":"1b25669d","713":"b08fbbf2","825":"5d07dbfc","836":"a652789d"}[chunkId] + ".chunk.js";
};